import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO, COMPANY } from "@/lib/assets";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back");
      navigate("/admin");
    } else {
      setError(res.error);
    }
  };

  const inputCls =
    "w-full bg-transparent border border-border px-4 py-3 focus:border-primary outline-none transition-colors";

  return (
    <div className="min-h-screen bg-foreground text-background flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <img src={LOGO} alt={COMPANY.short} className="h-12 w-auto object-contain bg-background/5 p-2 mb-10" />
        <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-primary mb-4">/ Admin Access</p>
        <h1 className="font-display text-4xl mb-10">Sign in to manage content</h1>

        <form onSubmit={submit} className="space-y-5" data-testid="login-form">
          <div>
            <label className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-background/60 block mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="login-email-input" />
          </div>
          <div>
            <label className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-background/60 block mb-2">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="login-password-input" />
          </div>
          {error && <p className="text-primary text-sm font-mono2" data-testid="login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-btn"
            className="w-full bg-primary text-primary-foreground py-4 font-mono2 text-xs uppercase tracking-[0.2em] hover:opacity-90 transition-opacity disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
